import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Div from '../Div';
import PageHeading from '../PageHeading';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';

const cardStyle = {
  padding: 30,
  borderRadius: 18,
  border: '1px solid rgba(255,255,255,0.1)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.015))',
  boxShadow: '0 20px 40px rgba(0,0,0,0.18)',
};

export function UatPageShell({ title, breadcrumb, subtitle, children, heading }) {
  useEffect(() => {
    pageTitle(title);
    window.scrollTo(0, 0);
  }, [title]);

  return (
    <>
      <PageHeading
        title={title}
        bgSrc="/images/service_hero_bg.jpeg"
        pageLinkText={breadcrumb || title}
      />
      <Spacing lg="120" md="70" />
      <Div className="container">
        <Div className="row justify-content-center">
          <Div className="col-lg-10">
            {heading ? (
              <>
                <SectionHeading
                  title={heading}
                  subtitle={subtitle || 'GTBank MPGS UAT'}
                  variant="cs-style1 text-center"
                />
                <Spacing lg="35" md="25" />
              </>
            ) : null}
            <Div style={cardStyle}>{children}</Div>
          </Div>
        </Div>
      </Div>
      <Spacing lg="120" md="70" />
    </>
  );
}

export function UatInfoRow({ label, value, accent }) {
  return (
    <Div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: 20,
        padding: '14px 0',
        borderBottom: '1px solid rgba(255,255,255,0.08)',
        flexWrap: 'wrap',
      }}
    >
      <strong style={{ color: accent ? '#ff4a17' : '#fff' }}>{label}</strong>
      <span style={{ textAlign: 'right' }}>{value}</span>
    </Div>
  );
}

export function UatNote({ children }) {
  return (
    <Div
      style={{
        marginTop: 24,
        padding: 18,
        borderRadius: 14,
        background: 'rgba(255,74,23,0.08)',
        border: '1px solid rgba(255,74,23,0.2)',
      }}
    >
      <p className="cs-m0" style={{ lineHeight: 1.8 }}>{children}</p>
    </Div>
  );
}

export function UatTable({ columns, rows }) {
  return (
    <Div style={{ overflowX: 'auto' }}>
      <table className="table" style={{ width: '100%', minWidth: 980, color: '#fff' }}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} style={{ whiteSpace: 'nowrap' }}>{column.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={`${rowIndex}-${row[columns[0].key]}`}>
              {columns.map((column) => (
                <td key={column.key}>{row[column.key]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </Div>
  );
}
